import { useState, useRef, useEffect } from "react";
import ReactMarkdown from "react-markdown";
import "../App.css";

type Message = {
  sender: "user" | "ai";
  text: string;
};

const WELCOME_MESSAGE: Message = {
  sender: "ai",
  text: "Bonjour 👋, je suis une IA qui connaît bien Ethan. Vous pouvez me poser des questions sur sa vie professionnelle par exemple.",
};

function ChatBox() {
  const [messages, setMessages] = useState<Message[]>([WELCOME_MESSAGE]);
  const [input, setInput] = useState("");
  const messagesRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const el = messagesRef.current;
    if (!el) return;
    el.scrollTo({ top: el.scrollHeight, behavior: "smooth" });
  }, [messages]);

  const handleSend = async () => {
    if (input.trim() === "") return;

    const userMessage: Message = { sender: "user", text: input };
    setMessages((prev) => [...prev, userMessage]);
    setInput("");

    try {
      const response = await fetch("https://portfoliov1-production-96c0.up.railway.app/chat", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ message: userMessage.text }),
      });

      const data = await response.json();

      if (data.error && data.error.message) {
        throw new Error(data.error.message);
      }

      const aiMessage: Message = { sender: "ai", text: data.response };
      setMessages((prev) => [...prev, aiMessage]);
    } catch (err: any) {
      console.error("Erreur API :", err);

      const errorMessage: Message = {
        sender: "ai",
        text: "⚠️ **Erreur technique** : Je ne peux pas répondre pour le moment. Réessayez plus tard.",
      };
      setMessages((prev) => [...prev, errorMessage]);
    }
  };

  return (
    <div className="chat-container">
      <h3 className="chat-title">Chat IA</h3>

      <div className="chat-messages" ref={messagesRef}>
        {messages.map((msg, index) => (
          <div key={index} className={`chat-message ${msg.sender}`}>
            {msg.sender === "ai" ? (
              <ReactMarkdown>{msg.text}</ReactMarkdown>
            ) : (
              msg.text
            )}
          </div>
        ))}
      </div>

      <div className="chat-input-container">
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleSend();
          }}
          placeholder="Posez une question à l'IA ..."
          className="chat-input"
        />
        <button onClick={handleSend} className="chat-button">
          Envoyer
        </button>
      </div>
    </div>
  );
}

export default ChatBox;